<div class="module-wrapper content-wrapper">
  <div class="form-wrapper">
    <div class="input-wrapper">
      <form [formGroup]='tagsForm'>
        <div class="input-class">

          <input type="text" placeholder="{{'itemDetails.TabTags.inputLabel' | translate}}"
            [readonly]='isPublished || (roleSer.accessData.tagAccessData?!roleSer.accessData.tagAccessData.insertAllowed || !roleSer.accessData.tagAccessData.updateAllowed :true)'
            class="form-control" [matAutocomplete]="auto" formControlName='userInput' filterValidator="Name">
        </div>
        <mat-autocomplete #auto="matAutocomplete" [displayWith]='displayFn'>
          <mat-option *ngIf="isLoading" class="is-loading">
            <mat-spinner diameter="50"></mat-spinner>
          </mat-option>
          <ng-container *ngIf="!isLoading">
            <mat-option (onSelectionChange)="addTagtoItem(tag)" *ngFor="let tag of flatTags" [value]="tag">
              <span>{{tag?.tagtypename}}</span>
              <span>-{{tag?.tagName}}</span>
            </mat-option>
          </ng-container>
        </mat-autocomplete>
      </form>
    </div>

    <div *ngIf="isNoTags" class="data-not-found-container table-container">
      <span>{{'itemDetails.TabTags.errorMsg' | translate}}</span>
    </div>
    <div *ngIf="!isNoTags">
      <div class="table-container">
        <table mat-table [dataSource]="tagTableDataSource" matSort class="mat-elevation-z8">
          <ng-container matColumnDef="tagtypename">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'itemDetails.TabTags.column1' | translate}}
            </th>
            <td mat-cell *matCellDef="let row" class="cell-content">
              <ng-container *ngIf="row?.tagtypename?.length > 40 then sliceTitle else noSliceTitle">
              </ng-container>
              <ng-template #sliceTitle>
                <div matTooltipClass="my-custom-tooltip" matTooltip="{{row?.tagtypename}}" matTooltipPosition="above">
                  {{row?.tagtypename | slice: 0:40}}...</div>
              </ng-template>
              <ng-template #noSliceTitle>
                <div>{{row?.tagtypename }}</div>
              </ng-template>
              <!-- {{row.tagtypename}} -->
            </td>
          </ng-container>
          <ng-container matColumnDef="tagdescription">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'itemDetails.TabTags.column2' | translate}}
            </th>
            <td mat-cell *matCellDef="let row" class="cell-content">
              <ng-container *ngIf="row?.tagName?.length > 40 then sliceTitle else noSliceTitle">
              </ng-container>
              <ng-template #sliceTitle>
                <div matTooltipClass="my-custom-tooltip" matTooltip="{{row?.tagName}}" matTooltipPosition="above">
                  {{row?.tagName | slice: 0:40}}...</div>
              </ng-template>
              <ng-template #noSliceTitle>
                <div>{{row?.tagName }}</div>
              </ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="itemTagId">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true"> {{'itemDetails.TabTags.column3' | translate}}
            </th>
            <td mat-cell *matCellDef="let row">
              <button mat-icon-button (click)='deleteItemTag(row.itembanktagid)' [ngClass]="{disableIcon : isPublished || (roleSer.accessData? !roleSer.accessData.tagAccessData.deleteAllowed:true)}"
              matTooltip="{{'itemDetails.TabTags.toolTip.delete' | translate}}">
                <mat-icon>delete_outline</mat-icon>
              </button>

              <!-- <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)='deleteItemTag(row.itembanktagid)'
                  [disabled]='isPublished || (roleSer.accessData? !roleSer.accessData.tagAccessData.deleteAllowed:true)'>
                  <mat-icon>delete_outline</mat-icon>
                  <span> {{'itemDetails.TabTags.toolTip.delete' | translate}}</span>
                </button>
              </mat-menu> -->
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <!-- <table mat-table [dataSource]="tagTableDataSource" matSort class="mat-elevation-z8">
          <ng-container matColumnDef="tagtypename">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'itemDetails.TabTags.column1' | translate}}</th>
            <td mat-cell *matCellDef="let row" class="cell-content">
              <ng-container *ngIf="row?.tagtypename?.length > 40 then sliceTitle else noSliceTitle">
              </ng-container>
              <ng-template #sliceTitle>
                <span matTooltipClass="my-custom-tooltip" matTooltip="{{row?.tagtypename}}" matTooltipPosition="above">
                  {{row?.tagtypename | slice: 0:40}}...</span>
              </ng-template>
              <ng-template #noSliceTitle>
                <span>{{row?.tagtypename }}</span>
              </ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="tagdescription">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
              {{'testId.TabTags.column2' | translate}}
            </th>
            <td mat-cell *matCellDef="let row" class="cell-content">
              <div *ngFor="let item of row.tags">
                <ng-container *ngIf="item?.tagName?.length > 40 then sliceTitle else noSliceTitle">
                </ng-container>
                <ng-template #sliceTitle>
                  <span matTooltipClass="my-custom-tooltip" matTooltip="{{item?.tagName}}" matTooltipPosition="above">
                    {{item?.tagName | slice: 0:40}}...</span>
                </ng-template>
                <ng-template #noSliceTitle>
                  <span>{{item?.tagName }}</span>
                </ng-template>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="itemTagId">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'itemDetails.TabTags.column3' | translate}}</th>
            <td mat-cell *matCellDef="let row">
              <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)='deleteItemTag(row.tagTypeId)'
                  [disabled]='isPublished || (roleSer.accessData? !roleSer.accessData.tagAccessData.deleteAllowed:true)'>
                  <mat-icon>delete_outline</mat-icon>
                  <span>{{'itemDetails.TabTags.toolTip.delete' | translate}}</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table> -->
      </div>
      <div class="item-paginator" *ngIf="showPaginator > 0">
        <mat-paginator [length]="tags.data.length" [pageSizeOptions]="[10, 50, 100]"
          showFirstLastButtons></mat-paginator>
      </div>
    </div>
  </div>
</div>